const CACHE_TTL_MS = 60_000;

let cachedValue = null;
let cachedAt = 0;
let inFlightPromise = null;

export async function fetchFleetStatsCached() {
  const now = Date.now();
  if (cachedValue && now - cachedAt < CACHE_TTL_MS) {
    return cachedValue;
  }

  if (inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = fetch("/api/fleet/stats")
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Failed to fetch /api/fleet/stats: HTTP ${res.status}`);
      }
      return res.json();
    })
    .then((payload) => {
      cachedValue = payload;
      cachedAt = Date.now();
      return payload;
    })
    .finally(() => {
      inFlightPromise = null;
    });

  return inFlightPromise;
}

export function clearFleetStatsCache() {
  cachedValue = null;
  cachedAt = 0;
  inFlightPromise = null;
}
